import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";
import translations from "../translations";
import eagleLogo from "../assets/frontart (3).svg";
import cloudtech from '../assets/cloudgreen.svg';
import cloudtech2 from '../assets/cloudgreen.svg';
import Fade from "react-reveal/Fade";
import { useSpring, animated } from "react-spring";

const DDosmain = () => {
  const navigate = useNavigate();
  const { lang } = useLanguage();
  const t = translations[lang];

  const [scrollY, setScrollY] = useState(0);
  const [scrollPercent, setScrollPercent] = useState(0);
  const eagleRef = useRef(null);
  const [isShieldVisible, setIsShieldVisible] = useState(true);
  const [shieldPosition, setShieldPosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const updateShieldInitialPosition = () => {
      if (eagleRef.current) {
        const eagleRect = eagleRef.current.getBoundingClientRect();
        setShieldPosition({ x: eagleRect.left, y: -1 * eagleRect.height - 48 });
      }
    };

    const handleScroll = () => {
      const scrollMax = document.documentElement.scrollHeight - window.innerHeight;
      const newScrollPercent = window.scrollY / scrollMax;
      if (isShieldVisible === true) setIsShieldVisible(false);
      setScrollPercent(newScrollPercent);
      setScrollY(Math.min(140, newScrollPercent * 140));
      setIsShieldVisible(true);
    };

    updateShieldInitialPosition();
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", updateShieldInitialPosition);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", updateShieldInitialPosition);
    };
  }, [isShieldVisible]);

  const eagleStyle = useSpring({
    transform: `scale(${1 + 1.3 * scrollPercent})`,
    position: 'relative',
    zIndex: -1,
  });
  const cloudTechStyle = useSpring({
    opacity: 1,
    transform: `translateX(${-40 + shieldPosition.x + (-5 * scrollY)}px) translateY(${100 + shieldPosition.y}px)`,
    position: 'absolute',
    zIndex: 3,
  });
  const cloudTech2Style = useSpring({
    opacity: 1,
    transform: `translateX(${40 + shieldPosition.x + 5 * scrollY}px) scaleX(-1) translateY(${100 + shieldPosition.y}px)`,
    position: 'absolute',
    zIndex: 3,
  });

  return (
    <div className="bg-white relative overflow-hidden" dir={lang === 'ar' ? 'rtl' : 'ltr'} style={{ position: "relative", zIndex: 2 }}>
      <Fade>
        <animated.div style={eagleStyle} className="text-center pt-10">
          <img ref={eagleRef} src={eagleLogo} alt="Eagle Logo" className="mx-auto w-72 h-80" />
        </animated.div>
      </Fade>
      <Fade left opposite delay={20} distance="10px">
        <animated.div style={cloudTechStyle} className="text-center absolute cloudtech-container">
          <img src={cloudtech} alt="Cloud Technology" className="w-72 h-72" />
        </animated.div>
      </Fade>
      <Fade right opposite delay={20} distance="10px">
        <animated.div style={cloudTech2Style} className="text-center absolute cloudtech2-container">
          <img src={cloudtech2} alt="Mirrored Cloud Technology" className="w-72 h-72" />
        </animated.div>
      </Fade>
      <Fade top>
        <div className="text-center px-6 py-16 md:py-20">
          <h2 className="text-4xl font-bold mb-4">{t.ddos_title}</h2>
          <div className="w-16 h-1 bg-[#97d700] mx-auto mb-6" />
          <p className="text-base md:text-lg mb-8 max-w-2xl mx-auto text-gray-600 leading-[1.9]">{t.ddos_body}</p>
          <button
            onClick={() => navigate("/anti-ddos")}
            className="bg-[#97d700] text-black font-semibold rounded-lg px-6 py-3 hover:bg-[#a8e600] transition-colors duration-200"
          >
            {t.ddos_cta}
          </button>
        </div>
      </Fade>
    </div>
  );
};

export default DDosmain;
